import { useForm } from "@kanda-libs/ks-component-ts";
import { UseFormReturn } from "react-hook-form";
import { useCallback, useState, type MouseEvent } from "react";
import useJobRevert from "components/job/JobRevertModal/useJobRevert";

export interface JobRevertModalPropsHook {
  form: UseFormReturn;
  areYouSure: boolean;
  onAreYouSure: (event: MouseEvent) => void;
  onClose: () => void;
  onSubmit: () => void;
  disabled: boolean;
  isSubmitting: boolean;
}

export default function useJobRevertModalProps(): JobRevertModalPropsHook {
  const form = useForm({ mode: "onBlur" });
  const [areYouSure, setAreYouSure] = useState(false);
  const { isSubmitting, onRevertJob } = useJobRevert();

  const onAreYouSure = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      setAreYouSure(true);
    },
    [setAreYouSure]
  );

  /**
   * Callback to set the areYouSure state to false when the modal is closed.
   */
  const onClose = useCallback(() => {
    setAreYouSure(false);
  }, [setAreYouSure]);

  const onSubmit = useCallback(() => {
    onRevertJob();
  }, [onRevertJob]);

  const safety = form.watch("safety");
  const disabled = safety !== "REVERT";

  return {
    form,
    areYouSure,
    onAreYouSure,
    onClose,
    onSubmit,
    disabled,
    isSubmitting,
  };
}
